import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Link } from '@mui/material';
import { RegisterCredentials } from '../../types/auth';

interface RegisterFormProps {
    onSubmit: (credentials: RegisterCredentials) => void;
    onToggleForm: () => void;
}

export const RegisterForm: React.FC<RegisterFormProps> = ({ onSubmit, onToggleForm }) => {
    const [credentials, setCredentials] = useState<RegisterCredentials>({
        email: '',
        password: '',
        confirmPassword: '',
    });

    const [error, setError] = useState('');

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (credentials.password !== credentials.confirmPassword) {
            setError('Passwords do not match');
            return;
        }
        onSubmit(credentials);
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <Typography component="h1" variant="h5" sx={{ mb: 3 }}>
                Sign Up
            </Typography>
            <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                autoComplete="email"
                autoFocus
                value={credentials.email}
                onChange={(e) => setCredentials({ ...credentials, email: e.target.value })}
            />
            <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                id="password"
                value={credentials.password}
                onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
            />
            <TextField
                margin="normal"
                required
                fullWidth
                name="confirmPassword"
                label="Confirm Password"
                type="password"
                id="confirmPassword"
                value={credentials.confirmPassword}
                onChange={(e) => setCredentials({ ...credentials, confirmPassword: e.target.value })}
                error={!!error}
                helperText={error}
            />
            <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
            >
                Sign Up
            </Button>
            <Link
                component="button"
                variant="body2"
                onClick={onToggleForm}
                sx={{ cursor: 'pointer' }}
            >
                Already have an account? Sign In
            </Link>
        </Box>
    );
};
